import Moment from 'moment-timezone'
import 'moment/locale/zh-cn'
import 'moment/locale/es'
import 'moment/locale/it'

const MomentRange = require('moment-range')
const moment = MomentRange.extendMoment(Moment)

export default moment
